module.exports = __webpack_public_path__ + "assets/images/shop1.17230a37.jpg";